import React from "react";
import { Phone, Mail } from "lucide-react";
import { useContactModal } from "@/components/site/ContactModalContext";

const Footer = () => {
  const year = new Date().getFullYear();
  const { open: openContactModal } = useContactModal();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1A1918] hairline-t pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-12 pb-12 border-b border-[#C89D54]/15">
          <div className="md:col-span-5">
            <div className="font-serif-display text-3xl text-[#F4F0EB] tracking-tight">
              M <span className="text-[#C89D54]">Skierniewski</span>
            </div>
            <p className="mt-4 font-sans-body text-sm text-[#A6A098] leading-relaxed max-w-sm">
              Professional McKenzie Friend offering family court support across
              Mansfield, Nottinghamshire, Derbyshire & Sheffield. Helping people
              represent themselves effectively — local, experienced and fully
              prepared to support you through every step.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Navigate</div>
            <ul className="space-y-2.5 text-sm">
              {[
                ["Home", "home"],
                ["About", "about"],
                ["Services", "services"],
                ["Why Choose Me", "why"],
                ["Contact", "contact"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() =>
                      document
                        .getElementById(id)
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="text-[#A6A098] hover:text-[#C89D54] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+447810620113"
                  className="flex items-center gap-3 text-[#F4F0EB] hover:text-[#C89D54] transition-colors"
                >
                  <Phone size={14} className="text-[#C89D54]" />
                  07810 620113
                </a>
              </li>
              <li>
                <button
                  type="button"
                  data-testid="footer-email-btn"
                  onClick={openContactModal}
                  className="flex items-center gap-3 text-[#F4F0EB] hover:text-[#C89D54] transition-colors break-all text-left"
                >
                  <Mail size={14} className="text-[#C89D54] shrink-0" />
                  Michaelskierniewski@gmail.com
                </button>
              </li>
            </ul>

            <div className="mt-6">
              <div className="overline mb-3">Available In</div>
              <div className="text-sm text-[#A6A098]">
                English <span className="text-[#C89D54]">·</span> Polski{" "}
                <span className="text-[#C89D54]">·</span> Русский{" "}
                <span className="text-[#C89D54]">·</span> Slovakian
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#A6A098]">
            © {year} Michael Skierniewski – All Rights Reserved.
          </p>
          <p className="text-xs text-[#A6A098] italic max-w-md md:text-right">
            Professional McKenzie Friend – Family Court Support – Mansfield,
            Nottinghamshire, Derbyshire & Sheffield.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
